exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardSalaryTotal-490db{display:flex;flex-direction:column;width:25%}.dashboardSalaryTotal-490db .totalItem-1b016{display:flex;justify-content:space-between;align-items:center;margin-bottom:15px}.dashboardSalaryTotal-490db .totalItem-1b016 .organization-c723b{font-weight:500}", ""]);

// Exports
exports.locals = {
	"dashboardSalaryTotal": "dashboardSalaryTotal-490db",
	"totalItem": "totalItem-1b016",
	"organization": "organization-c723b"
};